module.exports = __webpack_public_path__ + "img/groovy.92841df2.svg";